import { BaseApi } from 'src/api/BaseApi';
import { DEMO_KEYWORDS } from 'src/api/demo/keywords';

class KeywordApi extends BaseApi {
  async fetchKeywords() {
    if (this.isDemo()) return DEMO_KEYWORDS;

    const response = await this.postRequest('keywords');

    return response.data;
  }

  async submitKeyword(keyword, type) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id: Date.now(),
        keyword: { id: Date.now(), keyword, type, createdAt: new Date().toISOString() },
      });
    }

    const formData = this.createFormData({
      keyword,
      type,
    });

    const response = await this.postRequest('keywords/submit', formData);
    return response.data;
  }

  async updateKeyword(id, keyword, type) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id,
        keyword: { id, keyword, type },
      });
    }

    const formData = this.createFormData({
      id,
      keyword,
      type,
    });

    const response = await this.postRequest('keywords/update', formData);
    return response.data;
  }

  async deleteKeyword(id) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id,
        deleted: true,
      });
    }

    const formData = this.createFormData({
      id,
    });

    const response = await this.postRequest('keywords/delete', formData);
    return response.data;
  }
}

export const keywordApi = new KeywordApi();

